import {useRef} from 'react';
import {useNavigate} from 'react-router-dom';
import {Modal} from '@cvent/carina/components/Modal';
import {ROUTE_PREFIX} from '../../routes/new-routes';
import {Button} from '@cvent/carina/components/Button';
import {Illustration} from '@cvent/carina/components/Illustration';
import {useClearIncompleteBilling} from '../../hooks';

type IncompleteBillingModalProps = {
  redirectUrl: string;
};

const IncompleteBillingModal = ({redirectUrl}: IncompleteBillingModalProps) => {
  const headerRef = useRef<HTMLHeadingElement | null>(null);
  const navigate = useNavigate();
  const {clearIncompleteBilling, isLoading} =
    useClearIncompleteBilling(redirectUrl);

  const handleViewPlans = () => {
    navigate(`${ROUTE_PREFIX}/change-plan`, {
      state: {hasIncompleteBilling: true},
    });
  };

  return (
    <Modal
      isOpen
      format="sm"
      onDismiss={() => {}}
      testID="incomplete-billing-modal"
      aria-labelledby="incomplete-billing-title"
    >
      <div className="flex flex-col items-center box-border w-[420px] p-6 pt-4">
        <div aria-hidden>
          <Illustration name="calm" width="120" height="120" aria-hidden />
        </div>
        <h1
          id="incomplete-billing-title"
          ref={headerRef}
          tabIndex={-1}
          className="text-[24px] font-bold leading-[var(--carina-line-height-tight)] text-[var(--carina-text-color-base)] text-center mb-3"
        >
          You are almost set up
        </h1>
        <p className="text-center text-[14px] leading-[var(--carina-line-height-body-sm)] text-[var(--carina-text-color-muted)] mb-6">
          You selected a paid plan but didn&apos;t finish adding your billing
          details. Until then, your account is on the Free plan.
        </p>
        <div className="flex flex-col gap-3 w-full">
          <Button
            text="View plans"
            onClick={handleViewPlans}
            type="button"
            appearance="filled"
            isDisabled={isLoading}
            isBlock
          />
          <Button
            text="Continue with Free plan"
            onClick={clearIncompleteBilling}
            type="button"
            appearance="lined"
            isDisabled={isLoading}
            isBlock
          />
        </div>
      </div>
    </Modal>
  );
};

export default IncompleteBillingModal;
